import React from "react";
import { useSearchParams } from "react-router-dom";

import { useMeteredUsageCapabilities, useMeteredUsageEnterpriseCapabilities } from "components/RequirePermission/useCapabilities";

import MeteredUsageDashboard from "./MeteredUsageDashboard";
import MeteredExportHistory from "./MeteredExportHistory";
import MeteredUsageUserDetail from "./MeteredUsageUserDetail";

// /ecr-ops/metered-usage — billing usage across every organization (the enterprise-wide API tier, separate permissions).
// An organization can be picked (?org=); the page then shows that organization's data, so it needs the person's
// organization-level permissions for it as well as their enterprise ones.
const EnterpriseMeteredUsage = () => {
  const [searchParams] = useSearchParams();
  const caps = useMeteredUsageEnterpriseCapabilities();
  const orgCaps = useMeteredUsageCapabilities(searchParams.get("org") || null);
  return <MeteredUsageDashboard scope="enterprise" caps={caps} orgCaps={orgCaps} />;
};

// /ecr-ops/metered-usage/users/:userId
export const EnterpriseMeteredUsageUser = () => <MeteredUsageUserDetail scope="enterprise" caps={useMeteredUsageEnterpriseCapabilities()} />;

// /ecr-ops/metered-usage/exports — past metered usage reports, to download again while they are still available.
export const EnterpriseMeteredExportHistory = () => <MeteredExportHistory caps={useMeteredUsageEnterpriseCapabilities()} />;

export default EnterpriseMeteredUsage;
